export default __webpack_public_path__ + "static/media/inverted coma.de87a09a.svg";